import { FontAwesomeIcon } from "./FontAwesomeIcon"
import { faCaretDown } from "@fortawesome/free-solid-svg-icons"

export const CaretDown = (props) => {
  return <FontAwesomeIcon faIcon={faCaretDown} {...props} />
}
